<template>
  <div class="question-wrap" v-if="data">
    <img
      v-if="data.isView && data.answer === '-'"
      class="no-answer"
      src="@/assets/errors-no_answer.png"
      alt="未作答"
    />
    <card>
      <template #top>
        <div class="progress">{{ index + 1 }}/{{ total }}</div>
        <div class="question">{{ data.question }}</div>
      </template>
      <template #bottom>
        <div class="answers">
          <van-row
            type="flex"
            align="center"
            v-for="(value, key) in data.answer"
            :key="key"
            :class="[
              'answer-item',
              data.isView
                ? key === data.solution
                  ? 'true'
                  : key === data.choosen
                  ? 'false'
                  : ''
                : '',
            ]"
            @click="handleSelected(key)"
          >
            <van-col span="3"></van-col>
            <van-col span="18">{{ value }}</van-col>
            <van-col span="3">
              <template v-if="data.isView">
                <van-icon
                  v-if="key === data.solution"
                  name="success"
                  size="17"
                />
                <van-icon
                  v-else-if="key === data.choosen"
                  name="cross"
                  size="17"
                />
              </template>
            </van-col>
          </van-row>
        </div>
        <van-row
          v-if="data.isView"
          class="analysis"
          type="flex"
          justify="space-between"
          align="center"
        >
          <van-col span="24" style="margin-bottom: 12px"
            ><b>解析：</b>{{ data.analy }}</van-col
          >
          <van-col>
            <b>难度：</b
            ><van-rate
              style="vertical-align: middle"
              v-model="data.degree"
              :size="12"
              count="3"
              color="#FFA04B"
              readonly
            />
          </van-col>
        </van-row>
      </template>
    </card>
  </div>
</template>
<script>
import Card from "@/components/Card";
export default {
  components: {
    Card,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      require: true,
    },
    type: {
      type: Number,
      default: 0,
    },
    tag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answerMap: ["A", "B", "C", "D"],
    };
  },
  methods: {
    async handleSelected(key) {
      if (this.type == 2) {
        return;
      }
      if (key == this.answerMap.indexOf(this.data.correct)) {
        try {
          await this.$axios.post(`/Question/closeErrorBook`, {
            id: this.data.id,
          });
          this.data.solution = this.answerMap.indexOf(this.data.correct);
          this.$emit("update:tag", true);
          console.log("删除错题成功");
        } catch (error) {
          console.log(error);
        }
      } else {
        this.data.solution = this.answerMap.indexOf(this.data.correct);
        this.data.choosen = key;
      }
      this.data.isView = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.question-wrap {
  position: relative;

  .no-answer {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 43px;
  }
  .progress {
    padding-top: 11px;
    font-size: 15px;
    line-height: 15px;
    color: #999;
    text-align: center;
  }

  .question {
    position: relative;
    padding: 18px 17px 15px;
    font-size: 17px;
    font-weight: 500;
    line-height: 20px;
    color: #140661;

    &::before {
      position: absolute;
      right: 15px;
      bottom: 0;
      left: 15px;
      content: "";
      border: 0.5px dashed #e5e5e5;
    }
  }

  .answers {
    padding: 11px 34px 11px;

    .answer-item {
      padding: 12px 18px;
      margin-bottom: 6px;
      font-size: 14px;
      line-height: 17px;
      color: #000;
      text-align: center;
      background-color: #edf4ff;
      border-radius: 13px;

      &.true {
        position: relative;
        color: $white;
        background-color: $button-green-color;
      }

      &.false {
        position: relative;
        color: $white;
        background-color: $button-red-color;
      }

      .van-icon {
        vertical-align: top;
      }
    }
  }

  .analysis {
    position: relative;
    padding: 12px 34px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 18px;
    color: #000;
    background: #f4f4f4;

    b {
      font-weight: 600;
      vertical-align: middle;
    }
  }
}
</style>
